import '../../global'
import { transformFirestoreResponse } from '../utils/firestoreTransform'

export function formatMenus(data: any, restaurantId: string) {
	return {
		id: data.id,
		menuContent: data.menuContent,
		activeDateRanges: data.activeDateRanges,
		name: data.name,
		restaurantId: restaurantId,
		activeTimesOfWeek: data.activeTimesOfWeek,
		featuredItems: [],
		default: data.default,
		priority: data.priority ? data.priority : 9999,
	}
}
export const getMenuData = (restaurantId, snapshot) => {
	return new Promise((resolve, reject) => {
		const dataImport = {}

		snapshot.docChanges().forEach(change => {
			const data = change.doc.data()
			if (!data.isDeleted) {
				const menuReturn = formatMenus(data, restaurantId)
				const key = 'menus_for_' + restaurantId

				if (!dataImport[key]) {
					dataImport[key] = []
				}

				if (change.type === 'modified') {
					const index = dataImport[key].findIndex(i => i.id === data.id)
					if (index >= 0) {
						dataImport[key].splice(index, 1)
					}
				}

				dataImport[key].push(menuReturn)
			}
		})

		Object.keys(dataImport).forEach(key => {
			dataImport[key].sort((a, b) => b.priority - a.priority)
		})

		resolve(dataImport)
	})
}

export const getMenuDataForBot = (restaurantId, result) => {
	return new Promise((resolve, reject) => {
		const dataImport = {}

		result.forEach(data => {
			const formattedData = transformFirestoreResponse(data)

			if (!formattedData.isDeleted) {
				const menuReturn = formatMenus(formattedData, restaurantId)
				const key = 'menus_for_' + restaurantId

				if (!dataImport[key]) {
					dataImport[key] = []
				}

				dataImport[key].push(menuReturn)
			}
		})

		Object.keys(dataImport).forEach(key => {
			dataImport[key].sort((a, b) => b.priority - a.priority)
		})

		resolve(dataImport)
	})
}
